import { getCsrfToken } from '@/integrations/php/client';

export async function assignAdminLead(leadId: string, partnerId: string): Promise<void> {
  const response = await fetch('/api/admin/assign-lead.php', {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': await getCsrfToken() },
    body: JSON.stringify({ lead_id: leadId, partner_id: partnerId }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body?.error?.message || 'Δεν ήταν δυνατή η ανάθεση.');
}
